var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"button-remove",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$emit('remove')}}},[_vm._v("\n  \t×\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }